__turbopack_context__.v({
  "btn": "ScrollTop-module-scss-module__ocJczG__btn",
  "btnWrapper": "ScrollTop-module-scss-module__ocJczG__btnWrapper",
  "dNone": "ScrollTop-module-scss-module__ocJczG__dNone",
});
